import '../styles/main.scss'
import 'bootstrap';
import input_label from './components/input_label'
import postsFilter from "./components/postsFilter";
import accordion from "./components/accordion";


document.addEventListener('DOMContentLoaded', function () {
  //scrollUpHeader('.sticky-header', 50, 'show')

  input_label()
  accordion('.accordion')
  postsFilter('.posts-filters')
  // show filter

  var filterElement = document.querySelector('.red-bg');
  var filterButton = document.getElementById('filtersearch');


  // Check if the URL contains #filter-open
  if (window.location.hash === '#filter-open') {
    filterElement.classList.add('filter-active');
    filterButton.classList.add('active');
  }


  filterButton.addEventListener('click', function () {
    filterElement.classList.toggle('filter-active');
    filterButton.classList.toggle('active');
  });

})


jQuery(document).ready(function () {
  jQuery('.registration-popup input').focus(function () {
    jQuery(this).prev('label').css('color', '#543FD3');
  }).blur(function () {
    jQuery(this).prev('label').css('color', '#1A1A1A');
  });

  jQuery(document).on('click', '.login-trigger', function () {
    jQuery('.popup-overlay').fadeIn(150);
    jQuery('.registration-popup').fadeIn(150);
    jQuery('#login-user').removeClass('d-none');
  });

  jQuery(document).on('click', '.register-trigger', function () {
    jQuery('.popup-overlay').fadeIn(150);
    jQuery('.registration-popup').fadeIn(150);
    jQuery('#register-user').removeClass('d-none');
    jQuery('#register-user-form').hide();
    jQuery('#login-user').hide();
  });


  jQuery('.modal-close').click(function () {
    jQuery('.popup-overlay').hide();
    jQuery('.registration-popup').hide();
    jQuery('#login-user').show();
    jQuery('.registration-popup #register-user').addClass('d-none');
    jQuery('#register-user-form').show();
    jQuery('#reset-password-form').addClass('d-none');

  })

  jQuery('#register-user-form').click(function () {
    jQuery('#login-user').hide();
    jQuery('#register-user').removeClass('d-none');
    jQuery(this).hide();
  })

});

jQuery(document).ready(function ($) {


  $('#delete_logo_button').on('click', function(e) {

    e.preventDefault();

    if (confirm('Are you sure you want to delete the logo?')) {
      $('#delete_logo').val(1);

      $('#submit-all').trigger('click');    }
  })

  $('#desc-trigger').on('click', function() {
    $('#user-description-preview').hide();
    $('.textarea-wrapper').show();
  });

  const $dropdownSelected = $('.dropdown-selected');
  const $dropdownSelectedTxt = $('.dropdown-selected span');
  const $dropdownList = $('.dropdown-list');
  const $hiddenSelect = $('#forum-select');
  const dd = $('.custom-dropdown');

  $dropdownSelected.on('click', function () {
    $dropdownList.toggleClass('active');
    dd.toggleClass('active');

  });

  $dropdownList.on('click', '.dropdown-option', function () {
    const selectedText = $(this).text();
    const selectedValue = $(this).data('value');

    $dropdownSelectedTxt.text(selectedText);
    $hiddenSelect.val(selectedValue);
    $dropdownList.removeClass('active');
    dd.removeClass('active');

  });

  $(document).on('click', function (event) {
    if (!$dropdownSelected.is(event.target) && !$dropdownList.is(event.target) && $dropdownList.has(event.target).length === 0) {
      $dropdownList.removeClass('active');
      dd.removeClass('active');
    }
  });

  let sortDirection = {};

  $('.user-table-header .user-table-cell[data-sort]').click(function () {
    const $headerCell = $(this);
    const sortIndex = $headerCell.index();
    const isDateColumn = $headerCell.data('sort') === 'date';

    if (!sortDirection[sortIndex] || sortDirection[sortIndex] === 'desc') {
      sortDirection[sortIndex] = 'asc';
    } else {
      sortDirection[sortIndex] = 'desc';
    }

    const rows = $('.user-table-body .user-table-row').get();

    rows.sort(function (a, b) {
      const A = $(a).find('.user-table-cell').eq(sortIndex).text();
      const B = $(b).find('.user-table-cell').eq(sortIndex).text();

      if (isDateColumn) {
        const dateA = new Date(A.split('.').reverse().join('-'));
        const dateB = new Date(B.split('.').reverse().join('-'));

        return sortDirection[sortIndex] === 'asc'
            ? dateA - dateB
            : dateB - dateA;
      } else {
        const textA = A.toUpperCase();
        const textB = B.toUpperCase();

        if (textA < textB) return sortDi3rection[sortIndex] === 'asc' ? -1 : 1;
        if (textA > textB) return sortDirection[sortIndex] === 'asc' ? 1 : -1;
        return 0;
      }
    });

    $.each(rows, function (index, row) {
      $('.user-table-body').append(row);
    });

    $('span', this).toggleClass('up');
  });


  $('.tab-navigation .tab-button').on('click', function() {
    let topics = $(this).attr('data-tab');


    $('.tab-navigation .tab-button').removeClass('active');
    $(this).addClass('active');

    $('.topics-list').removeClass('active-tab');
    $('#'+ topics).addClass('active-tab');

  })

  $('.form-terms span').on('click', function () {
    var checkbox = $(this).siblings('input[type="checkbox"]');
    checkbox.prop('checked', !checkbox.prop('checked'));
  });

});

document.getElementById('company_logo').addEventListener('change', function() {
  if (this.files.length > 0) {
    jQuery('#submit-all').trigger('click');
  }
});
